import { ChatRoom } from 'models/ChatRoom';
import { isMatchOnlyMode } from 'react/netplay/netplayPageState';

// A chat_rooms push (from the socket or an API answer) applied to the player's
// rooms. Every page applies it: the dock (react/dock/chat) shows the rooms off
// the netplay page too. The match popup has no rooms.
export default function applyChatRooms(response, fromSocket) {
	if(isMatchOnlyMode()) {
		return;
	}
	if(!response.chat_rooms || !response.chat_rooms.chat_room) {
		return;
	}
	for(let chatRoomId in response.chat_rooms.chat_room) {
		if(!response.chat_rooms.chat_room.hasOwnProperty(chatRoomId)) {
			continue;
		}
		const chat = response.chat_rooms.chat_room[chatRoomId];
		if(chatRoomId && !chat.id) {
			chat.id = chatRoomId;
		}
		ChatRoom.addMessagesToProperChatRoom(chat, chat.chat_messages, fromSocket);
	}
}
